import { render } from "./IconExel.vue?vue&type=template&id=309d8124"
import script from "./IconExel.vue?vue&type=script&lang=js"
export * from "./IconExel.vue?vue&type=script&lang=js"
script.render = render

export default script